import authentication from "@irati/auth"
import {FeedEntityType, GroupCelebration, PaymentCurrencyType, Recognition, WalletEntityType} from "@irati/types"
import RecognitionService from "@irati/recognition/services/Recognition"
import flexiPointService from "@irati/wallet/services/flexiRewards"
import walletService from "@irati/wallet/graph/wallet"

interface TBudget {
  categoryId: string
  useUnassigned: boolean
}
const attachRewardToEntity = async (
  destinationUserIds: string[],
  pointsPerUser: number,
  item: Recognition | GroupCelebration,
  type: FeedEntityType,
  budget?: TBudget
) => {
  if (type !== FeedEntityType.GroupCelebration && type !== FeedEntityType.Recognition) {
    return
  }
  const wallet = await walletService.get(authentication.user().uuid!, PaymentCurrencyType.Rp, WalletEntityType.Reward)
  let rewardMessage
  if (type === FeedEntityType.Recognition) {
    const recognition = item as Recognition
    rewardMessage = recognition.message!
  }
  if (type === FeedEntityType.GroupCelebration) {
    const groupCelebration = item as GroupCelebration
    const greetingLabel = `${groupCelebration?.greeting?.label}, ${groupCelebration?.receiver.firstName} ${groupCelebration?.receiver.lastName}`
    const userComment = groupCelebration.messages?.find((messageItem) => messageItem.authorId === authentication.user().uuid)
    rewardMessage = userComment?.message || greetingLabel
  }
  const variables = {
    sourceId: wallet.uuid!,
    destinationUserIds,
    amount: pointsPerUser * 100,
    message: rewardMessage,
    budget
  }
  const totalAmount = pointsPerUser * destinationUserIds.length
  if (wallet.availableBalance! < totalAmount) {
    return
  }
  const {transferIds} = await flexiPointService.rewardEmployees(variables)
  const {status} = await flexiPointService.getTransferOutcome(transferIds[0])
  if (status !== "COMPLETE") {
    throw Error("Transfer failed")
  }
  if (type === FeedEntityType.Recognition) {
    return RecognitionService.updateRecognitionWithReward(item.uuid!, transferIds[0])
  }
  if (type === FeedEntityType.GroupCelebration) {
    return RecognitionService.updateGroupCelebration({groupCelebrationID: item.uuid!, walletTransferId: transferIds[0]})
  }
}

export default attachRewardToEntity
